import React, {useMemo} from "react"
import {Pie, PieChart} from "recharts"
import {Box, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import SquareIcon from "@mui/icons-material/Square";
import {Insurancetype} from "models";

export default function InsuranceTypeDistributionPieChart({ certificates = []}) {
  const insuranceTypeLookup = {
    [Insurancetype.GL]: 0,
    [Insurancetype.AU]: 1,
    [Insurancetype.UMB]: 2,
    [Insurancetype.WC]: 3,
    [Insurancetype.CUSTOM]: 4,
  }
  const data = useMemo(() => {
    const toReturn = [
      { name: "General Liability", value: 0, fill: "#0c84f5" },
      { name: "Automobile", value: 0, fill: "#b180d1" },
      { name: "Umbrella", value: 0, fill: "#f57d42" },
      { name: "Workers Comp", value: 0, fill: "#f6b52a" },
      { name: "Others", value: 0, fill: "#12bd9a" },
    ]

    certificates.forEach(cert => {
      let coverages = []
      try {
        coverages = JSON.parse(cert.coverages)
      } catch(e) {
        console.error('[InsuranceTypeDistribution] Error parsing coverages:', e)
      }
      coverages.forEach(coverage => {
        if(coverage.policyExp?.length || coverage.policyNumber) {
          const typeIndex = insuranceTypeLookup[coverage.insuranceType] ?? insuranceTypeLookup[Insurancetype.CUSTOM]
          toReturn[typeIndex].value = toReturn[typeIndex].value + 1
        }
      })
    })

    return toReturn
  }, [certificates])

  const hasData = data.some(item => item.value > 0);

  return (
    <Box padding={2}>
      <Typography variant="h4" sx={{mb:1}}>
        Insurance Type Distribution
      </Typography>
      <Typography variant="subtitle1" fontSize={"1.5rem"} color={"gray"}>
        Breakdown of insurance documents by type
      </Typography>
      {hasData ? (
        <PieChart width={300} height={300} style={{marginLeft: "auto", marginRight: "auto"}}>
          <Pie
            data={data.filter(oneData => oneData.value)}
            cx={150}
            cy={150}
            outerRadius={80}
            dataKey="value"
            label={({ percent }) => {
              if(percent) {
                return `${(percent * 100).toFixed(0)}%`
              }
            }}
          />
        </PieChart>
      ) : (
        <Box
          height={300}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            backgroundColor: '#f8fafc',
            borderRadius: 2,
            marginY: 2
          }}
        >
          <Typography variant="h6" color="text.secondary">
            No insurance data available
          </Typography>
        </Box>
      )}
      <Stack>
        {data.map((status, index) => (
          <Stack direction="row" key={index}>
            <SquareIcon sx={{color: status.fill}}/>
            <Box flexGrow={1} paddingLeft={1}>{status.name}</Box>
            <Box>{ certificates.length ? status.value : 0} documents</Box>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}
